module.exports = __webpack_public_path__ + "0aa7ff34c549026e3f57f3e19ea60abe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_50.jpg
// module id = 1749
// module chunks = 5